export const ROUTE_APP = '/';
export const ROUTE_HOME = ROUTE_APP;
export const ROUTE_SIGNIN = '/signin';
export const ROUTE_SIGNUP = '/signup';
export const ROUTE_RESET_PASSWORD = '/resetpassword';
export const ROUTE_PROFILE = '/profile/:userId';
export const ROUTE_PROFILE_CURRENT = '/profile';
export const ROUTE_EDIT_PROFILE = '/edit-profile/:userId';
export const ROUTE_EDIT_PROFILE_CURRENT = '/edit-profile';

export const ROUTE_DASHBOARD = '/home';
export const ROUTE_REPORTING = '/reports/:category/:report';

export const ROUTE_CLUBS = '/clubs';
export const ROUTE_CLUB = '/club/:clubNo/:subpage/:mode';
export const ROUTE_CHAMPIONSHIPS = '/championships';
export const ROUTE_CHAMPIONSHIP = '/championships/:championshipNo/:subpage/:mode';
export const ROUTE_MEMBERS = '/members';
export const ROUTE_MEMBER = '/member/:clubNo/:memberNo/:subpage/:mode';
export const ROUTE_PIGEON_HOLE = '/pigeon-hole/:clubNo/:holeNo/:subpage/:mode';

export const ROUTE_RACES = '/races';
export const ROUTE_RACE = '/races/:raceNo/:subpage/:mode';

export const ROUTE_SECTIONS = '/sections';
export const ROUTE_SECTION = '/section/:sectionNo/:subpage/:mode';
export const ROUTE_STATIONS = '/stations';
export const ROUTE_RANGES = '/ranges';
export const ROUTE_ZIPS = '/zip-codes';
export const ROUTE_NIGHT_TIMES = '/night-times';
export const ROUTE_DERBYS = '/derbys';

export const ROUTE_SETTINGS = '/settings/:subpage/:sectionNo/:mode';
export const ROUTE_ERROR_LISTS = '/error-lists/:subpage';
export const ROUTE_IMPORT_FILE = '/api/club-program/:fileType/:club/:week';
export const ROUTE_DEVICES_EXPORT = '/api/device-export/:club/:pigeonhole/eleksyst';



// WEBPACK FOOTER //
// ./src/client/src/constants/routeconstants.js